import {
  Box,
  Flex,
  Button,
  Text,
  Heading,
  IconButton,
  Image,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  // primary,
  // secondary,
  white,
  buttonRed,
  buttonRedText,
  primaryAlt,
  textSecondary,
  backgroundLight,
  buttonRedDark,
} from "../../../../utils/colors";
import { FaArrowLeftLong } from "react-icons/fa6";
import useThemeColors from "../../../../hooks/useThemeColors";
import SubscriptionBillingDetails from "./partials/SubscriptionBillingDetails";
import { cancelTenantSubscriptionAction } from "../../../../actions/paymentActions";
import ManageSubscriptionLimits from "./partials/ManageSubscriptionLimits";

const ManageSubscriptionSidepanel = ({
  slug,
  selectedSubscription,
  setSidePanelOpen,
}) => {
  // GENERAL
  const { t, i18n } = useTranslation();
  // const toast = useToast();

  // const stripe = useStripe();

  const { backgroundLightMode, newBorderMode, textPrimaryMode } =
    useThemeColors();

  // STATE

  // ERROR STATES

  // REDUX
  const dispatch = useDispatch();

  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const tenantDetailsBySlug = useSelector((state) => state.tenantDetailsBySlug);
  const { tenant } = tenantDetailsBySlug;

  // const paymentTenantCancelSubscription = useSelector(
  //   (state) => state.paymentTenantCancelSubscription
  // );
  // const { loading, success, error } = paymentTenantCancelSubscription;

  // HANDLERS
  const closeHandler = () => {
    setSidePanelOpen(false);
  };

  // console.log("selectedSubscription:", selectedSubscription);

  const handleCancelSubscription = () => {
    const tenantSubscription = selectedSubscription;
    dispatch(cancelTenantSubscriptionAction(slug, tenantSubscription));
  };

  // USE EFFECT
  // const { loading, checkoutUrl, error } = useSelector(
  //   (state) => state.paymentSubscription
  // );

  // useEffect(() => {
  //   if (checkoutUrl) {
  //     window.location.href = checkoutUrl; // Redirect to Stripe checkout page
  //   }
  // }, [checkoutUrl]);
  // useEffect(() => {
  //   if (success) {
  //     toast({
  //       title: t("module.subscriptionCancelled"),
  //       status: "success",
  //       duration: 5000,
  //       isClosable: true,
  //     });
  //     // dispatch({ type: PAYMENT_TENANT_SETUP_INTENT_RESET });
  //     // dispatch({
  //     //   type: PAYMENT_TENANT_CANCEL_SUBSCRIPTION_RESET,
  //     // });
  //     // dispatch(listTenantDetails());

  //     dispatch(listTenantDetailsBySlugAction(slug));
  //     closeHandler();
  //   }
  //   if (error) {
  //     toast({
  //       title: t("module.error"),
  //       description: error,
  //       status: "error",
  //       duration: 5000,
  //       isClosable: true,
  //     });
  //   }

  //   // dispatch({
  //   //   type: PAYMENT_TENANT_CANCEL_SUBSCRIPTION_RESET,
  //   // });
  // }, [success, error, slug]);

  // ERROR

  // LOGS
  // console.log("activeClientSecret:", activeClientSecret);
  // console.log("activeSetupIntentSecret:", activeSetupIntentSecret);
  // console.log("selectedSubscription:", selectedSubscription);

  console.log("selectedSubscription:", selectedSubscription);

  return (
    <Box position="relative" bg={white}>
      {/* HEADER START */}

      <Flex
        justify="space-between"
        align="center"
        p="1.25rem 2rem 1.25rem"
        borderBottom={`1px solid ${newBorderMode}`}
        mb="0rem"
        position="relative"
        zIndex={90}
        w="100%"
      >
        <Flex align="center">
          <IconButton
            bg={backgroundLightMode}
            border={`1px solid ${backgroundLightMode}`}
            color={textSecondary}
            icon={<FaArrowLeftLong />}
            borderRadius="10.75rem"
            fontSize="0.875rem"
            onClick={closeHandler}
            mr="1rem"
            _hover={{
              bg: primaryAlt,
              color: white,
              border: primaryAlt,
            }}
          />

          <Flex align="center">
            <Heading
              fontSize="1.125rem"
              color={textPrimaryMode}
              fontWeight="600"
              mr={4}
            >
              {t("module.manageSubscription")}
            </Heading>
            {/* {status} */}
          </Flex>
        </Flex>
      </Flex>
      {/* HEADER END */}

      {/* MAIN START */}
      <Box>
        <Box
          w="100%"
          h="calc(100vh - 60px)"
          overflow="scroll"
          p={["0 1.5rem", "0 2rem", "0 2rem"]}
          minW="800px"
          maxW="800px"
        >
          <Flex
            direction="column"
            w="100%"
            align="flex-start"
            justify="center"
            p="0rem 0 0"
          >
            <Flex w="100%" gap="2rem" direction="column">
              <Flex
                w="100%"
                align="center"
                justify="flex-end"
                gap="0rem"
                p="1rem 0 8rem"
                direction="column"
              >
                <Box w="100%" m="1rem 0 0">
                  <Text
                    fontSize="0.875rem"
                    fontWeight="600"
                    color={textPrimaryMode}
                    m="0 0 0.5rem"
                  >
                    {t("module.subscriptionInfo")}
                  </Text>

                  <Flex
                    direction="column"
                    w="100%"
                    // bg={backgroundLight}
                    // borderRadius="1rem"
                    // p="1.5rem"
                  >
                    <Flex
                      // bg={white}
                      borderRadius="1rem"
                      // p="1.25rem 1.5rem"
                      w="100%"
                      align="center"
                      justify="space-between"
                      gap="2rem"
                    >
                      <Flex
                        w="50%"
                        // bg={primaryAlt}
                        bg={backgroundLight}
                        borderRadius="1rem"
                        p="1.5rem"
                        direction="column"
                      >
                        <Flex align="center">
                          <Image
                            src="/icons/treatment.svg"
                            opacity="0.8"
                            position="relative"
                            top="-1px"
                            mr={1}
                          />
                          <Text
                            fontSize="md"
                            fontWeight="500"
                            color={textPrimaryMode}
                          >
                            {t(`module.${selectedSubscription.name}`)}
                          </Text>
                        </Flex>
                        <Box>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="500"
                            color={textSecondary}
                            m="0.5rem 0 0"
                          >
                            75 plans per month
                          </Text>
                        </Box>
                      </Flex>
                      <Flex
                        w="50%"
                        bg={white}
                        borderRadius="1rem"
                        p="1.5rem"
                        border={`1px solid ${newBorderMode}`}
                      >
                        <Box w="100%">
                          <Flex w="100%" align="center" justify="space-between">
                            <Flex align="center" gap="0rem">
                              {/* <Icon
                                as={TbWallet}
                                color={textSecondary}
                                fontSize="1rem"
                              /> */}
                              <Text
                                fontSize="md"
                                fontWeight="500"
                                color={textPrimaryMode}
                              >
                                Next payment
                              </Text>
                            </Flex>
                            <Text
                              fontSize="md"
                              fontWeight="600"
                              color={textPrimaryMode}
                            >
                              {selectedSubscription.priceAmount} $
                            </Text>
                          </Flex>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="500"
                            color={textSecondary}
                            m="0.25rem 0 0"
                          >
                            Next billing on 15th of every month
                          </Text>
                        </Box>
                      </Flex>

                      {/* <NextPaymentDetails
                        subscription={selectedSubscription}
                        isActive={true}
                        moduleName={selectedSubscription.name}
                        plan={selectedSubscription.plan}
                        nextBillingDate={selectedSubscription.nextBillingDate}
                      /> */}
                    </Flex>
                  </Flex>
                </Box>

                <ManageSubscriptionLimits
                  isActive={true}
                  selectedSubscription={selectedSubscription}
                />

                {/* 
                <ModuleLimits
                  isActive={true}
                  moduleName={selectedSubscription.name}
                  plan={selectedSubscription}
                  nextBillingDate={selectedSubscription.nextBillingDate}
                /> */}
                {/* <Box w="100%">
                  <Text
                    fontSize="0.875rem"
                    fontWeight="600"
                    color={textPrimaryMode}
                    m="0 0 0.5rem"
                  >
                    {t("module.usageDetails")}
                  </Text>

                  <Flex
                    direction="column"
                    w="100%"
                    bg={backgroundLight}
                    borderRadius="1rem"
                    p="1.25rem 1.5rem 1.25rem"
                  >
                    <Flex
                      bg={white}
                      borderRadius="1rem"
                      p="1.25rem 1.5rem"
                      w="100%"
                    >
                      <ModuleLimits
                        isActive={true}
                        moduleName={selectedSubscription.name}
                        plan={selectedSubscription.plan}
                        nextBillingDate={selectedSubscription.nextBillingDate}
                      />
                    </Flex>
                  </Flex>
                </Box> */}
                {/* <SubscriptionInfoManage subscription={selectedSubscription} /> */}
                <SubscriptionBillingDetails
                  tenant={tenant}
                  subscription={selectedSubscription}
                />
                <Flex align="center" justify="flex-end" w="100%" m="2rem 0 0">
                  <Button
                    size="lg"
                    bg={buttonRed}
                    color={buttonRedText}
                    borderRadius="10rem"
                    fontSize="sm"
                    fontWeight="500"
                    p="0.5rem 1rem"
                    onClick={handleCancelSubscription}
                    _hover={{
                      bg: buttonRedDark,
                      color: white,
                    }}
                    // isLoading={loading}
                    isDisabled={
                      selectedSubscription.stripeSubscriptionStatus ===
                      "cancelling"
                    }
                  >
                    {t("module.cancelSubscription")}
                  </Button>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Box>
      </Box>
      {/* MAIN END */}
    </Box>
  );
};

export default ManageSubscriptionSidepanel;
